<template>
<transition name="slide-fade">
    <div class="dialog-view invite_apply" v-if="dialogVisible" ref="modal">     
        <div class="u-window invite-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper dialog-content">
                <div class="dialog-body">
                    <div class="dialog-title t-invite">助力有礼</div>
                    <div class="invite-view">
                        <div class="share-text msg-view">
                            <div class="text-content">
                                <p>邀请<b>3</b>位好友助力后可领取</p>
                            </div>
                        </div>

                        <div class="reward-view flex-center-center">
                            <div class="reward-item" v-tips="'JM04'">
                                <div class="reward-pic r-1"></div>
                                <div class="item-name">双11助力包</div>
                            </div>
                            <div class="reward-item">
                                <div class="reward-pic r-2"></div>
                                <div class="item-name">8折优惠券</div>
                            </div>
                        </div>

                        <div class="invite-list">
                            <div class="list-item" v-for="(item,index) in friend_list" :key="'f-' + index">{{ item.nickName }}</div>
                            <div class="list-item default" v-for="n in (3 - friend_list.length)" :key="n">待邀请</div>
                        </div>

                        <div class="u-btn copy" v-if="friend_list.length < 3" @click="call_copy()"></div>
                        <div class="u-btn get-buff" v-if="friend_list.length >= 3 && !buff" @click="get_buff()"></div>
                        <div class="u-btn dismiss" v-if="buff"></div>
                    </div>

                </div>

            </div>         
        </div>
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
import {
    apiGetBuff,   
} from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            error_text : '请稍后再试', 
            error : false,
            shareTxt : '',
            buff : false,
            friend_list : [], // 好友列表              
        }
    },
    created (){   
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        get_buff(){
            apiGetBuff().then(
                res => {
                    this.buff = true;
                    this.$store.commit("$_setBuff", this.buff);
                    this.$toast('获取补贴成功~');
                    this.$msg_modal({ text : '恭喜您获得双11分享礼，助力包已发送至军师邮件，请注意查收，本次活动【百亿补贴】中所有商品全部八折！！' , fromType : 1});
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },              
        call_copy(){
            this.destroyElement();
            this.$copy_modal({ shareTxt : this.shareTxt }); 
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              clipboard.destroy();
              _this.$toast("复制成功");
              _this.destroyElement();
            });
            clipboard.on('error', function () {
              clipboard.destroy()
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },             
    },
}
</script>

<style lang="scss" scoped>
.invite-modal{
    // width: 671px;
    // height: 896px;
    // padding-top: 342px;
    // border: none;
    // background-color: transparent;
    // border-radius: 0;
    // background-image: url(~@/assets/images/modal/bg-modal-invite.png);
}

.dialog-view .dialog-content{
    // border: none;
    // padding: 0;
    // border-radius: 0;
}

.t-invite{
    margin-bottom: 26px;
}

.invite-view{
    padding: 0 20px 0;
}

.reward-view{
    margin-bottom: 10px;
    .reward-item{
        width: 148px;
        margin: 0 25px;
    }

    .reward-pic{
        width: 86px;
        height: 86px;
        margin: 0 auto;

        &.r-1{
            background-image: url(~@/assets/images/modal/pack-share.png);
        }

        &.r-2{
            background-image: url(~@/assets/images/modal/ticket.png);
        }        
    }

    .item-name{
        margin-top: 6px;
        font-size: 22px;
        color: #999999;
        text-align: center;
    }
}

.text-content{
    margin-bottom: 20px;
    font-size: 22px;
    color: #666565;
    line-height: 1.4;
    text-align: center;

    p{
        margin: 0;
    }

    b{
        color: #ea583f;
    }
}

.invite-list{
    .list-item{
        width: 420px;
        height: 70px;
        line-height: 70px;
        margin: 0 auto 20px;
        text-align: center;
        border-radius: 5px;
        font-size: 20px;
        background-color: #faf1e1;
        color: #df977a;
        border: 1px solid #f5c2ad;

        &.default{
            color: #999999;
        }
    }
}



.notice{
    margin-top: 20px;
    font-size: 18px;
    color: #ee6044;
    text-align: center;
}

.info{
    font-size: 20px;
    text-align: center;
    margin-bottom: 18px;
}

.u-btn.copy{
    width: 190px;
    height: 54px;
    margin: 5px auto 0;
    background-image: url(~@/assets/images/modal/btn-invite.png);
} 

.u-btn.get-buff{
    width: 190px;
    height: 54px;
    margin: 5px auto 0;
    background-image: url(~@/assets/images/modal/btn-buff.png);
} 

.u-btn.dismiss{
    width: 190px;
    height: 54px;
    margin: 5px auto 0;
    background-image: url(~@/assets/images/modal/btn-dismiss.png);
} 

</style>